module.exports = __webpack_public_path__ + "img/bahrain.69f6805a.svg";